import { CHANGE_PASSWORD_URL, DASHBOARD_URL, FORGET_PASSWORD_URL, LOGIN_URL, LOGS_URL, NOTIFICATIONS_URL, OTP_URL, TRANSACTIONS_URL } from '../../constant';
import { guestRequest, resourceRequest } from '../calls'

export function doUserLogin(username, password) {
    const data = {
        'email': username,
        'password': password,
    }
    return guestRequest(LOGIN_URL, data)
}

export function doVerifyOTP(username, OTP) {
    const data = {
        "email": username,
        "otp": OTP,
    }
    return guestRequest(OTP_URL, data)
}

export function doForgetPassword(data) {
    return guestRequest(FORGET_PASSWORD_URL, data);
}

export function doChangePassword(token, data) {
    return resourceRequest(token, CHANGE_PASSWORD_URL, data)
}

export function doFetchDashboard(token) {
    const data = {}
    return resourceRequest(token, DASHBOARD_URL, data)
}

export function doFetchTransactions(token) {
    const data = {}
    return resourceRequest(token, TRANSACTIONS_URL, data);
}

export function doFetchNotifications(token) {
    const data = {}
    return resourceRequest(token, NOTIFICATIONS_URL, data);
}

export function doFetchLogs(token) {
    const data = {}
    return resourceRequest(token, LOGS_URL, data);
}